import { SOURCE_LOCALE_ID } from "@bitcart/core/i18n";
import { useClientLocaleId } from "@bitcart/hooks";
import { useLingui } from "@lingui/react";
import { useCallback } from "react";
import { usePageContext } from "vike-react/usePageContext";
import { navigate } from "vike/client/router";
// src/i18n/hooks/locale-change.ts
const useHandleLocaleChange = ({ supportedLocaleIds }) => {
	const { urlLogical } = usePageContext();
	const { i18n } = useLingui();
	const { setClientLocaleId } = useClientLocaleId({ supportedLocaleIds });
	return useCallback((localeId, callback) => {
		if (localeId === i18n.locale) callback?.();
		else {
			setClientLocaleId(localeId);
			callback?.();
			const navigationParams = {
				keepScrollPosition: true,
				overwriteLastHistoryEntry: true
			};
			if (localeId === SOURCE_LOCALE_ID) navigate(urlLogical, navigationParams);
			else navigate(`/${localeId}` + (urlLogical === "/" ? "" : urlLogical), navigationParams);
		}
	}, [
		i18n.locale,
		setClientLocaleId,
		urlLogical
	]);
};
export { useHandleLocaleChange };

//# sourceMappingURL=locale-change.js.map